<template>
    <div>
        <h1>About Us</h1>
        <!-- 关于页面的内容 -->
        <p>关于我们的详细内容，关于我们的详细内容，关于我们的详细内容...</p>
        <img alt="Vue logo" src="../assets/logo.png">
        <p>关于我们的详细内容，关于我们的详细内容，关于我们的详细内容...</p>
    </div>
</template>

<script>
    export default {
        name: 'About'
    };  
</script>